// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T0Mg","colBig":"styles_colBig__2wgsZ","colSmall":"styles_colSmall__1li_I"};